import { useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import "../styles/ui.scss";
import "../styles/main.scss";
import { getEnvironmentDomain, getSubdomainFromUrl } from "../helpers/GlobalHelper";
import { MsalConstants, Sites } from "./constants/GlobalConstants";
import { getSite } from "../helpers/PermissionHelper";

const BCSubdomain = ({ cookies, removeCookie }) => {
  const history = useHistory();
  const handleRouteToHome = useCallback(() => {
    history.push("/");
  }, [history]);

  useEffect(() => {
    const handleRemoveSessionCookies = () => {
      for (let i=0; i<MsalConstants.SessionLength; i++) {
        removeCookie(`msal_key${i+1}`);
        removeCookie(`msal_value${i+1}`);
      }

      removeCookie("msal_state");
    };

    if ((getSite() === Sites.Hosts.SYL || getSite() === Sites.Hosts.BUILDERS_CAPITAL_SYL) && process.env.REACT_APP_ENV !== "LOCAL") {
      const subdomain = getSubdomainFromUrl();
      if (subdomain && subdomain !== MsalConstants.CentralRedirectSubdomain) {
        if (subdomain && subdomain !== MsalConstants.CentralRedirectSubdomain && cookies.msal_key1 && 
          cookies.msal_key2 && cookies.msal_key3 && cookies.msal_key4 && cookies.msal_key5 &&
          cookies.msal_value1 && cookies.msal_value2 && cookies.msal_value3 && cookies.msal_value4 && cookies.msal_value5) {
            for (let i=0; i<MsalConstants.SessionLength; i++) {
              localStorage.setItem(cookies[`msal_key${i+1}`], JSON.stringify(cookies[`msal_value${i+1}`]));
            }
            
            handleRemoveSessionCookies();
            window.location.href = `http://${subdomain}${getEnvironmentDomain()}`;
          }
      }
    }

    handleRouteToHome();
  }, []);

  return (
    <></>
  );
};

export default BCSubdomain;